import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a1f2851"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "search" }, "Search", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "submit",
  value: "Search"
}, null, -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArtistCard = _resolveComponent("ArtistCard")!
  const _component_ArtworkCard = _resolveComponent("ArtworkCard")!
  const _component_ShowCard = _resolveComponent("ShowCard")!
  const _component_MainLayout = _resolveComponent("MainLayout")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.filter(_ctx.search)), ["prevent"]))
      }, [
        _hoisted_1,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "search",
          placeholder: "My artist",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event))
        }, null, 512), [
          [_vModelText, _ctx.search]
        ]),
        _hoisted_2
      ], 32),
      (_ctx.artists.length && _ctx.search)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredArtists, (artist) => {
              return (_openBlock(), _createBlock(_component_ArtistCard, {
                key: artist.id,
                artist: artist
              }, null, 8, ["artist"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.artworks.length && _ctx.search)
        ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredArtworks, (artwork) => {
              return (_openBlock(), _createBlock(_component_ArtworkCard, {
                key: artwork.id,
                artwork: artwork,
                role: _ctx.authStore.userRole
              }, null, 8, ["artwork", "role"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.shows.length && _ctx.search && _ctx.authStore.userRole !== 'private_seller')
        ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredShows, (show) => {
              return (_openBlock(), _createBlock(_component_ShowCard, {
                key: show.id,
                exhibition: show
              }, null, 8, ["exhibition"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}